import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogParams } from '@interfaces/dialogParam.interface.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { DialogFormCasoComponent } from '../dialog-form-caso/dialog-form-caso.component';
import { ButtonNewComponent } from '@component/button-new/button-new.component';
import { BuscarCasoComponent } from '@views/busquedas/buscar-caso/buscar-caso.component';
import { CasoService } from '@services/caso/caso.service';
import { T } from '@fullcalendar/core/internal-common';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseDto } from '@models/base/baseDto.model';

@Component({
  selector: 'app-btn-nuevo-caso',
  standalone: true,
  imports: [ButtonNewComponent],
  template: `<app-button-new (click)="openDialog({ accion: accionesDialog.Agregar, entidad: {} })"></app-button-new>`,
  styleUrl: './btn-nuevo-caso.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BtnNuevoCasoComponent {
  @ViewChild('buscarCasoComponent') buscarCasoComponent!: BuscarCasoComponent;
  accionesDialog = AccionesDialog;

  constructor(private dialog: MatDialog, private casoService: CasoService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
  ) {




  }

  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.data = data

    switch (accion) {
      case AccionesDialog.Ver:
        dialogConfig.width = "70%"
        break;

      default:
        dialogConfig.width = "50%"
        break;
    }

    const dialogRef = this.dialog.open(DialogFormCasoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.getById(result.data.id)
          break;
        case AccionesDialog.Modificar:
          break;
        case AccionesDialog.Eliminar:
          break;
        default:

          break;
      }

    });
  }

  getById(id: number) {
    this.spinner.show('spExpediente')
    this.casoService.getById(id)
      .subscribe(
        data => {
          this.buscarCasoComponent.getAll()
          this.buscarCasoComponent.casoDto = data
          let casoEntrada = new BaseDto
          casoEntrada.id = data.id
          casoEntrada.descripcion = data.caratula

          this.buscarCasoComponent.casoEntrada  = casoEntrada
        },
        error => {
          this.spinner.hide('spExpediente')
          this.snackBar.showError(error, "Error");
        })
  }
}






